import { parseCookieValue } from "@tm/isomorphic-utils";
import type { AxiosRequestHeaders } from "axios";

function getHost(headers: any) {
  let goibiboHost = process.env["MOCK_HOST"] || headers?.["x-goibibo-host"];
  if (goibiboHost && goibiboHost.includes("goibibo")) {
    goibiboHost = "www.goibibo.com";
  }
  return goibiboHost || headers?.["x-forwarded-host"] || headers?.["host"];
}

export function enhanceRequestHeaders(
  headers?: AxiosRequestHeaders
): AxiosRequestHeaders {
  const {
    cookie = "",
    "mmt-auth": mmtAuth,
    "OAUTH-GOIBIBO": oauthGoibibo,
    "mobile-device": mobile_device,
    cmp,
    dvid,
    "device-id": device_id,
    ...restHeaders
  } = headers || {};

  const resolvedMmtAuth =
    mmtAuth || parseCookieValue(cookie as string, "mmt-auth");
  const resolvedOauthGoibibo =
    oauthGoibibo || parseCookieValue(cookie as string, "OAUTH-GOIBIBO");

  let x_tm_device = mobile_device === "true" ? "mobile" : "desktop";
  const goMmtHost = getHost(headers);

  if (typeof window !== "undefined") {
    x_tm_device = /Mobile|Android|BlackBerry/.test(navigator.userAgent)
      ? "mobile"
      : "desktop";
  }

  if (typeof cmp === "string" && cmp != "") {
    return {
      cmp,
      cookie,
      "x-tm-device": x_tm_device,
      "X-Tm-Client": "desktop",
      "device-id": dvid || device_id || "",
      "Content-Type": "application/json",
      ...(resolvedMmtAuth ? { "mmt-auth": resolvedMmtAuth } : {}),
      ...(resolvedOauthGoibibo
        ? { "OAUTH-GOIBIBO": resolvedOauthGoibibo }
        : {}),
      ...(headers?.["x-ins-gommt-host"] || goMmtHost
        ? { "x-ins-gommt-host": headers?.["x-ins-gommt-host"] || goMmtHost }
        : {}),
    };
  }

  return {
    cookie,
    "x-tm-device": x_tm_device,
    "X-Tm-Client": "desktop",
    "device-id": dvid || device_id || "",
    "Content-Type": "application/json",
    ...(resolvedMmtAuth ? { "mmt-auth": resolvedMmtAuth } : {}),
    ...(resolvedOauthGoibibo ? { "OAUTH-GOIBIBO": resolvedOauthGoibibo } : {}),
    ...(headers?.["x-ins-gommt-host"] || goMmtHost
      ? { "x-ins-gommt-host": headers?.["x-ins-gommt-host"] || goMmtHost }
      : {}),
  };
}
